<template>
  <div class="description faq">
    <h4>What is this site about?</h4>
    <p>This website ranks the top 10 cryptocurrencies by market cap, allows you to easily compare cryptocurrency performance and rank over the last week.</p>
    <h4>Where is the data obtained from?</h4>
    <p>The data is from CryptoCompare, and is updated every 30 seconds.</p>
    <h4>Who created this site?</h4>
    <p>Hi there, I built this site from scratch, from the design, to the development; it is all hand-coded in my free time. I like to build apps that can solve problems, or impact someone's life in a small way.</p>
    <p>
      You can find me on my
      <a :href="websiteAddress" target="_blank" rel="noopener">website</a>, twitter
      <a :href="twitterAddress" target="_blank" rel="noopener">@jacobtyq</a> or at my
      <a :href="blogAddress" target="_blank" rel="noopener">blog</a> where I share my musings.
    </p>
    <h4>Why did I create this site?</h4>
    <p>I originally built this site to get better at VueJS, a front-end framework for building web interfaces.</p>
    <p>
      I built websites and web applications and you can see them over at my
      <a
        :href="websiteAddress"
        target="_blank"
        rel="noopener"
      >site</a>.
    </p>
    <h4>How can I support this site?</h4>
    <p>
      If you find this site useful and would like to keep it going, you could either
      <a
        :href="buyCoffeeAddress"
        target="_blank"
        rel="noopener"
      >buy me a coffee ☕️</a>&nbsp; or donate either BTC/ETH at any of the addresses below 😄
    </p>
  </div>
</template>

<script>
export default {
  name: "about",
  data: function() {
    return {
      websiteAddress: "https://jacobtan.co/",
      twitterAddress: "https://twitter.com/jacobtyq",
      blogAddress: "https://blog.jacobtan.co",
      buyCoffeeAddress: "https://www.buymeacoffee.com/watchcrypto"
    };
  }
};
</script>

<style lang="scss">
.faq {
  max-width: 540px;
  width: calc(100% - (16px * 3));

  margin: 0 auto;

  padding: 16px;
  border-radius: 4px;

  background: #ffffff;
  position: relative;
  box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.25);

  h4 {
    text-align: center;
    font-size: 1.4rem;
  }

  p {
    color: rgb(33, 33, 33);
  }

  a {
    color: #6ca9ea;

    &:visited {
      text-decoration: underline;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/About.vue